import React, { useState } from 'react';
import {
		Modal,
		Backdrop,
		Fade,
		TextField,
		Button,
		makeStyles,
		Typography,
		Box
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
		modal: {
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
		},
		paper: {
				backgroundColor: theme.palette.background.paper,
				borderRadius: 8,
				boxShadow: theme.shadows[5],
				padding: theme.spacing(4),
				width: 400,
				outline: 'none',
		},
		input: {
				marginBottom: theme.spacing(2),
		},
		buttonGroup: {
				display: 'flex',
				justifyContent: 'flex-end',
				marginTop: theme.spacing(2),
				gap: theme.spacing(1),
		},
}));

export default function ModalPessoaValor({ open, onClose, onSave }) {
		const classes = useStyles();
		const [documento, setDocumento] = useState('');
		const [valor, setValor] = useState('');

		const handleValorChange = (e) => {
				let val = e.target.value.replace(/\D/g, '');
				if (!val) {
						setValor('');
						return;
				}

				// Formata em R$ automaticamente
				val = (Number(val) / 100).toFixed(2) + '';
				val = val.replace('.', ',');
				val = val.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
				setValor(val);
		};

		const handleSave = () => {
				onSave({
						documento: documento.trim(),
						valor,
				});
				setDocumento('');
				setValor('');
				onClose();
		};

		const handleClose = () => {
				setDocumento('');
				setValor('');
				onClose();
		};

		return (
				<Modal
						open={open}
						onClose={handleClose}
						className={classes.modal}
						closeAfterTransition
						BackdropComponent={Backdrop}
						BackdropProps={{ timeout: 400 }}
				>
						<Fade in={open}>
								<div className={classes.paper}>
										<Typography variant="h6" gutterBottom>
												Dados da Pessoa
										</Typography>

										<TextField
												label="CPF ou CNPJ"
												variant="outlined"
												fullWidth
												value={documento}
												onChange={(e) => setDocumento(e.target.value)}
												className={classes.input}
										/>

										<TextField
												label="Valor (R$)"
												variant="outlined"
												fullWidth
												className={classes.input}
												value={valor ? `R$ ${valor}` : ''}
												onChange={handleValorChange}
										/>

										<Box className={classes.buttonGroup}>
												<Button onClick={handleClose} color="secondary">
														Cancelar
												</Button>
												<Button
														variant="contained"
														color="primary"
														onClick={handleSave}
														disabled={!documento || !valor}
												>
														Enviar
												</Button>
										</Box>
								</div>
						</Fade>
				</Modal>
		);
}
